/**
 * SearchModal Theme
 *
 * @override
 * - Desktop: nav row hidden while search open; modal positioned below collapsed header (ResizeObserver)
 * - Uses global blur overlay instead of ModalOverlay
 * - Modal content positioned below header (desktop only, calculated dynamically)
 * - On mobile: Full screen modal with header inside
 * - blockScrollOnMount: true to lock body scroll when modal is open
 */

import {A11Y_ICON_GLYPH_SIZE, A11Y_ICON_TARGET_MIN} from '@amblique/king-living/app/theme/foundations/a11y-targets';

export default {
  parts: [
    'modal',
    'content',
    'contentContainer',
    'mobileHeader',
    'logoMobileWrapper',
    'logoMobile',
    'closeButton',
    'body',
    'container',
    'contentInner',
  ],
  baseStyle: {
    modal: {
      blockScrollOnMount: true,
    },
    content: {
      bg: 'brandColors.primaryBG',
      backdropFilter: 'blur(20px)',
      position: 'relative',
      minHeight: {base: '100dvh', lg: 'auto'},
      display: {base: 'flex', lg: 'flex'},
      flexDirection: 'column',
      height: {base: '100dvh', lg: 'auto'},
      maxHeight: {base: '100dvh', lg: 'none'},
      maxW: '100%',
      m: {base: 0, lg: 'auto'},
      overflowX: 'hidden',
      overflowY: 'hidden',
      width: '100%',
    },
    contentInner: {
      maxWidth: '1440px',
      mx: 'auto',
      width: 'full',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      flex: {base: '1 1 auto', lg: '1 1 auto'},
      height: {base: '100%', lg: '100%'},
      minHeight: {base: 0, lg: 0},
      minW: 0,
      overflowX: 'hidden',
      overflowY: {base: 'hidden', lg: 'hidden'},
      paddingTop: {base: '0', md: '26px'},
    },
    contentContainer: {
      style: {
        // Above global blur overlay (1590) so search UI is not covered
        zIndex: 1600,
      },
    },
    mobileHeader: {
      display: {base: 'flex', lg: 'none'},
      alignItems: 'center',
      flexShrink: 0,
      justifyContent: 'space-between',
      paddingX: {base: '20px', md: '20px'},
      paddingTop: {base: '22px', lg: 0},
      paddingBottom: {base: '22px', lg: 0},
      minH: {base: '60px', lg: 'unset'},
      h: {base: '60px', lg: 'auto'},
      borderBottom: 'none',
    },
    logoMobileWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 'auto',
      padding: 0,
      height: 'auto',
      sx: {
        svg: {
          width: '100%',
          height: '100%',
        },
      },
    },
    logoMobile: {
      maxWidth: {base: '76px', md: '76px'},
      maxHeight: {base: '17px', md: '17px'},
    },
    closeButton: {
      position: {base: 'relative', lg: 'absolute'},
      top: {base: 'auto', lg: 6},
      right: {base: 'auto', lg: 7.5},
      zIndex: 10,
      alignItems: 'center',
      display: 'inline-flex',
      justifyContent: 'center',
      width: A11Y_ICON_TARGET_MIN,
      height: A11Y_ICON_TARGET_MIN,
      minWidth: A11Y_ICON_TARGET_MIN,
      minHeight: A11Y_ICON_TARGET_MIN,
      opacity: {base: 1, lg: 0.3},
      _hover: {opacity: {base: 0.7, lg: 0.5}},
      sx: {
        svg: {
          height: A11Y_ICON_GLYPH_SIZE,
          width: A11Y_ICON_GLYPH_SIZE,
        },
      },
    },
    body: {
      bg: 'transparent',
      flex: '1 1 auto',
      minHeight: 0,
      minW: 0,
      overflowX: 'hidden',
      overflowY: 'auto',
      borderTopWidth: {base: '1px', lg: 0},
      borderTopStyle: {base: 'solid', lg: 'none'},
      borderTopColor: {base: 'brandColors.greyscale10', lg: 'transparent'},
      paddingBottom: 6,
      px: {base: 5, md: 7.5},
      pt: 6,
      pb: {base: 10, md: 20},
      sx: {
        WebkitOverflowScrolling: 'touch',
      },
    },
    container: {
      maxW: {base: 'full', md: '1060px'},
      minW: 0,
      overflowX: 'hidden',
      paddingRight: 0,
      paddingLeft: 0,
      width: 'full',
    },
  },
};
